
import { 
  Datagrid,  
  List,  
  TextField,
  ShowButton
   } from 'react-admin';

export const OwnChannelList = () => (
  <List pagination={false} >
      <Datagrid bulkActionButtons={false}>
        <ShowButton/>
        <TextField source="name" />
        <TextField source="averageRetentionPercentage" />
        <TextField source="averageRetentionDuration" />
        <TextField source="averageViewsLast24h" label='Avearge Views last 24h' />
      </Datagrid>
  </List>
);

